import { FC } from "react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components/Badge";
import { LEAD_TYPE_LABEL, LeadType } from "views/leads-id/types";

export const LeadTypeBadge: FC<{ leadType: LeadType }> = ({ leadType }) => (
  <Badge
    variant={BadgeVariant.PRIMARY}
    size={BadgeSize.SM}
    className={
      leadType === LeadType.Owner ? "!bg-info-50 !text-info-700" : undefined
    }
  >
    {LEAD_TYPE_LABEL[leadType] ?? leadType}
  </Badge>
);
